import { Box } from '@mui/material';
import React, { ReactElement, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/hooks';
import { useSitesWithGoods } from '../../../hooks/useSitesWithGoods';
import { RootState } from '../../../redux/reducers';
import { setBareGoodsEntities } from '../../../redux/actions/orderActions';
import { convertGoodsIdsToBareGoodsEntities } from './OrderFormHelper';
import { filterUniqueBareGoodsByArticle } from '../../../redux/actions/helper';
import { importArticles } from '../../../redux/actions/articleActions';
import OrderFormGoodsWriteOffInTransportElement from './OrderFormGoodsWriteOffInTransportElement';
import { GoodsStatus } from '../../../api/ClientApi';

export default function ReceptionOrderFormGoods(): ReactElement {
    const order = useAppSelector((state: RootState) => state.orderForm.order);
    const orderedGoods = useAppSelector((state: RootState) => state.goodsToOrderForm.bareGoodsEntities);
    const sites = useSitesWithGoods();

    const allArticles = useAppSelector((state: RootState) => state.articles.articles);

    // if orderId exists, get all goods for order and set them as existing goods
    useEffect(() => {
        if (!!order?.id && !!order.goodsIds && order.goodsIds.length > 0) {
            const site = sites?.find((s) => s.id === order.originSiteId);

            const existingBareGoods = convertGoodsIdsToBareGoodsEntities(
                order.goodsIds,
                order.goods?.filter((g) => g.goodsStatus === GoodsStatus.InTransport) ?? [],
                [],
                site,
            );

            const filteredGoods = filterUniqueBareGoodsByArticle(existingBareGoods);

            dispatch(setBareGoodsEntities(filteredGoods));
        }
    }, [order]);

    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!allArticles) {
            dispatch(importArticles());
        }
    }, [dispatch]);

    return (
        <Box
            sx={{
                overflow: 'auto',
                p: 2,
            }}
        >
            <Box>
                {orderedGoods?.map((bareGoods) => {
                    return (
                        <Box key={bareGoods.index} sx={{ mb: 2 }}>
                            <OrderFormGoodsWriteOffInTransportElement orderedBareGoods={bareGoods} />
                        </Box>
                    );
                })}
            </Box>
        </Box>
    );
}
